module.exports = __webpack_public_path__ + "img/quick_set.7753576b.svg";